module.exports = __webpack_public_path__ + "img/48_4.1fae9aaf.png";